import { render } from "./Filtros.vue?vue&type=template&id=61fd9476&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"empresas\":\"data\",\"obtenerEmpresas\":\"options\"}"
import script from "./Filtros.vue?vue&type=script&lang=js"
export * from "./Filtros.vue?vue&type=script&lang=js"
script.render = render

export default script